module.exports = __webpack_public_path__ + "img/empty-pc.9012966.png";